import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
// import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import successGif from "assets/images/icons/success-green.gif";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import * as auth from "store/auth/user/action";
import { useDispatch, useSelector } from "react-redux";
import { ButtonLoader } from "components/__new/common/form";


export const GetStartedSuccess = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { id, activationToken } = useParams();

    const { verifyAccountLoading, verifyAccount, resendMailLoading } = useSelector((s) => s.auth.user);
    const { signupUser } = useSelector((s) => s.auth.userPersist);

    const [pageAccess, setPageAccess] = useState("");

    const resendMail = () => {
        if (signupUser){
            if ("email" in signupUser){
                dispatch(auth.resendVerifyEmail(signupUser.email));
            }
            else{
                // toast.error("Unable to resend confirmation email");
                history.push("/account-confirmation");
            }
        }
        else{
            history.push("/account-confirmation");
        }
    }

    useEffect(() => {
        let newPageAccess = "";
        if (id && id !== "" && activationToken && activationToken !== ""){
            if ((id !== "") && (activationToken !== "")) {
                newPageAccess = true;
                dispatch(auth.verifyAccount(id, activationToken));
            }
            else{
                newPageAccess = false;
            }
        }
        else{
            newPageAccess = false;
        }
        setPageAccess(newPageAccess)

        return () => { 
            dispatch(auth.resetResendVerifyEmail());
        }; 

        // eslint-disable-next-line
    }, [])


    return (
        <>

            <DynamicHeadTag
                headerText="Verify Account"
            />

            <div className="p-8">
                <div>

                    {(pageAccess === false) &&
                        <div className="text-center">
                            <div className="table-info">
                                <FontAwesomeIcon icon="exclamation-circle" className="text-red-700" style={{"fontSize":"4.5rem"}} />
                                <div className="mt-2 font-bold text-2xl text-black">
                                    Link Broken
                                </div>
                                <div className="mt-1">
                                    Sorry, your activation link is broken.&nbsp;
                                    <br className="hidden md:block" />
                                    Please contact us if you feel this error is from us.
                                </div>
                                <div className="mt-4 space-y-2">
                                    <ButtonLoader type="button" onClick={resendMail} loading={resendMailLoading} className="btn btn-lg btn-block btn-ep-primary">
                                        Resend Confirmation Email
                                    </ButtonLoader>
                                    {/* 
                                    <button type="button" onClick={this.toggleChatWidget} className="btn btn-block btn-lg btn-transparent-black mx-auto">
                                        Contact Us
                                    </button>
                                     */}
                                    <Link to="/login" className="btn btn-lg btn-block text-ep-primary font-semibold mt-3 hover:bg-gray-100">
                                        Back to Login
                                    </Link>
                                </div>
                            </div>
                        </div>
                    }

                    {(pageAccess === true) &&
                        <>

                            {(verifyAccountLoading === true) &&
                                <div className="text-center">
                                    <div className="table-info">
                                        <FontAwesomeIcon icon="circle-notch" spin style={{"fontSize":"4.5rem"}} />
                                        <div className="mt-2 font-bold text-2xl text-black">
                                            Confirming your account...
                                        </div>
                                        <div className="hidden mt-2">
                                            Please wait while we confirm your account.
                                        </div>
                                    </div>
                                </div>
                            }

                            {(verifyAccountLoading === false) && (verifyAccount === false) &&
                                <div className="text-center">
                                    <div className="table-info">
                                        <FontAwesomeIcon icon="exclamation-circle" className="text-red-700" style={{"fontSize":"4.5rem"}} />
                                        <div className="mt-2 font-bold text-2xl text-black">
                                            Confirmation failed
                                        </div>
                                        <div className="mt-1">
                                            Sorry, your account could not be confirmed.&nbsp;
                                            <br className="hidden md:block" />
                                            Please contact us if you feel this error is from us.
                                        </div>
                                        <div className="mt-4 space-y-2">
                                            <ButtonLoader type="button" onClick={resendMail} loading={resendMailLoading} className="btn btn-lg btn-block btn-ep-primary">
                                                Resend Confirmation Email
                                            </ButtonLoader>
                                            {/* 
                                            <button type="button" onClick={this.toggleChatWidget} className="btn btn-block btn-lg btn-transparent-black mx-auto">
                                                Contact Us
                                            </button>
                                             */}
                                            <Link to="/login" className="btn btn-lg btn-block text-ep-primary font-semibold mt-3 hover:bg-gray-100">
                                                Back to Login
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            }

                            {(verifyAccountLoading === false) && (verifyAccount === true) &&
                                <div className="text-center">
                                    <div className="table-info max-w-sm">
                                        <div className="h-48 sm:h-56">
                                            <img src={successGif} alt="Success" className="h-full object-contain mx-auto" />
                                        </div>
                                        <div className="mt-8 font-semibold text-lg lg:text-xl text-black whitespace-nowrap w-full">
                                            Account Confirmed Successfully
                                        </div>
                                        <div className="mt-4 mb-20 text-gray-500">
                                            Awesome! You have successfully confirmed your account.
                                            Proceed to login.
                                        </div>
                                        <Link to="/login" className="btn btn-lg btn-block btn-ep-primary mt-8">Login</Link>
                                    </div>
                                </div>
                            }
                        </>
                    }

                </div>
            </div>

        </>
    )
}


export default GetStartedSuccess;